import * as React from "react";
import styles from "./HeaderBadge.module.css";

export function HeaderBadge(props: { children: any }) {
  return <div className={styles.badge}>{props.children}</div>;
}
